import { ReduxStore } from 'store/types';

function getAllErrorMessage(state: ReduxStore): string {
  return state.manufacturer.getAll.config.errorMessage;
}

export default getAllErrorMessage;
